import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";
import { Product } from "@/types";

const GET_PRODUCTS = gql`
  query GetProducts(
    $brandId: Uuid!
    $filter: ProductsFilterInput
    $pointId: Uuid!
  ) {
    products(input: { brandId: $brandId, filter: $filter }) {
      id
      name
      slug
      description
      isActive
      categoryBinds {
        categoryId
        priority
      }
      images {
        url
        priority
      }
      pricePoint(input: { pointId: $pointId, orderType: PRE_ORDER })
    }
  }
`;

interface UseProductsResult {
  products: Product[];
  loading: boolean;
  error: Error | undefined;
  refetch: () => void;
}

interface UseProductsVariables {
  brandId: string | null;
  pointId: string | null;
  filter?: {
    isActive?: boolean;
    categoryId?: string;
  };
}

export const useProducts = ({
  brandId,
  pointId,
  filter,
}: UseProductsVariables): UseProductsResult => {
  const { data, loading, error, refetch } = useQuery(GET_PRODUCTS, {
    variables: {
      brandId,
      pointId,
      filter: {
        isActive: true,
        ...filter,
      },
    },
    skip: !brandId || !pointId,
    errorPolicy: "all",
  });

  return {
    products: data?.products || [],
    loading,
    error,
    refetch,
  };
};
